import { useTranslation } from 'react-i18next'

const SiblingStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="sibling-start-title"
      {...props}
    >
      <title id="sibling-start-title">{t('antagonists:sibling:components:end')}</title>
      <defs>
        <clipPath id="sibling-b">
          <path
            d="M1558.9 955.15s-7.72 15.81-7.98 23.37c-.26 7.57 0 7.57 2.06 12.91s4.12 21.59 4.12 21.59 14.41-.22 24.96-.44 19.24-.95 19.81-1.56c2.1-2.23 2.32-12.47-.51-14.91-2.83-2.45-10.81-11.58-12.35-18.92s-1.8-18.48-1.8-18.48l-28.31-3.56Z"
            style={{
              fill: '#645e18',
            }}
          />
        </clipPath>
        <clipPath id="sibling-c">
          <path
            d="M1483.08 964.88s2.29 9.02 3.37 18.77c1.08 9.76 1.09 18.84 1.09 18.84s-32.93 2.9-42.56 5.7c-9.63 2.8-29.27 3.24-38.27 2.41-9.01-.84-16.83-3.56-16.83-3.56s-3.06-10.57 5.14-13.22c8.2-2.65 23.08-8 29.28-13.67 6.21-5.67 21.88-24.66 21.88-24.66s14.14-5.5 12.74 3.46c-1.4 8.96-.47 17.28 9.26 16.48 9.73-.8 14.89-10.54 14.89-10.54Z"
            style={{
              fill: '#645e18',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:#008db5}.e{fill:#efbbba}.f{fill:#ed7a30}.g{fill:#feca21}.h{fill:#a4cbba}.i{fill:#d78b3b}.j{fill:#e0a758}.k{fill:#235a96}.l{fill:#6d9454}.m{fill:#645e18}.n{clip-path:url(#sibling-c)}.o{clip-path:url(#sibling-b)}'
          }
        </style>
      </defs>
      <path
        d="m1647.39 488.53-18.55 17.62s-17.35 64.89-10.73 88.12c6.62 23.23 15.9 64.73 13.27 76.84-2.63 12.12-.42 18.87-.34 25.9.08 7.02 1 17 1 17s5.01 1.29 6.71-3.99c1.7-5.29.51-11.35 4.3-10.99 3.79.36 2.11 10.45.12 13.57-1.99 3.13-8.57 6.44-9.82 9.36-1.25 2.92-1 7.17-1 7.17s14.58-6.71 18.87-9.06c4.29-2.34 7.14-19.32 7.82-24.8.68-5.48-6.03-21.53-5.09-33.97.94-12.43 3.98-64.32 3.25-80.93-.73-16.6-4.69-21.71-5.41-30.79-.4-5-4.4-61.06-4.4-61.06Z"
        style={{
          fill: '#e0a758',
        }}
      />
      <path
        d="m1621.27 557.37.03.68c-.1-.42-.15-.65-.15-.65l.12-.03Z"
        style={{
          fill: '#efbbba',
        }}
      />
      <path
        d="M1470.24 502.72h27.41s8.54 66.63-1.12 88.78c-9.66 22.14-24.39 62.03-23.4 74.38.99 12.36-2.11 18.76-3.12 25.71-1.02 6.95-3.26 16.72-3.26 16.72s-5.14.61-6.11-4.85c-.98-5.46 1-11.32-2.79-11.47-3.8-.15-3.48 10.07-1.93 13.44 1.56 3.37 7.63 7.53 8.48 10.59.85 3.06.03 7.24.03 7.24s-13.55-8.6-17.49-11.49c-3.94-2.9-4.5-20.1-4.44-25.62.06-5.52 8.38-11.12 9.11-23.57.73-12.45 5.11-73.69 8.04-90.05 2.94-16.36 7.54-20.89 9.47-29.8 1.06-4.9 1.14-40 1.14-40Z"
        style={{
          fill: '#e0a758',
        }}
      />
      <path
        d="M1483.25 934.52s0 42.75-.8 42.75-35.12-.79-35.12-.79 4.59-45.41 4.85-44.62c.27.8 31.07 2.66 31.07 2.66Z"
        style={{
          fill: '#a4cbba',
        }}
      />
      <path
        d="M1558.9 955.15s-7.72 15.81-7.98 23.37c-.26 7.57 0 7.57 2.06 12.91s4.12 21.59 4.12 21.59 14.41-.22 24.96-.44 19.24-.95 19.81-1.56c2.1-2.23 2.32-12.47-.51-14.91-2.83-2.45-10.81-11.58-12.35-18.92s-1.8-18.48-1.8-18.48l-28.31-3.56Z"
        style={{
          fill: '#645e18',
        }}
      />
      <g
        style={{
          clipPath: 'url(#sibling-b)',
        }}
      >
        <path
          d="M1552.98 1005.23s18.33-3.86 28.4-3.29c10.07.57 23.78 1.14 23.78 1.14l1.98 16.43-58.62.43 4.46-14.71Z"
          style={{
            fill: '#ed7a30',
          }}
        />
      </g>
      <path
        d="M1483.08 964.88s2.29 9.02 3.37 18.77c1.08 9.76 1.09 18.84 1.09 18.84s-32.93 2.9-42.56 5.7c-9.63 2.8-29.27 3.24-38.27 2.41-9.01-.84-16.83-3.56-16.83-3.56s-3.06-10.57 5.14-13.22c8.2-2.65 23.08-8 29.28-13.67 6.21-5.67 21.88-24.66 21.88-24.66s14.14-5.5 12.74 3.46c-1.4 8.96-.47 17.28 9.26 16.48 9.73-.8 14.89-10.54 14.89-10.54Z"
        style={{
          fill: '#645e18',
        }}
      />
      <g
        style={{
          clipPath: 'url(#sibling-c)',
        }}
      >
        <path
          d="M1384.44 996.6s25.6 7.12 42.63 4.16 28.57-6.34 38.27-6.86 25.3-3.33 25.3-3.33l-2.85 18.48-109.91 6.26s7.15-18.93 6.56-18.7Z"
          style={{
            fill: '#ed7a30',
          }}
        />
      </g>
      <path
        d="M1487.71 625.37s-25.23 76.48-31.63 103.7c-6.4 27.21-17.34 74.33-19.9 85.28-4.72 20.17 2.84 75.05 1.87 96.25-.96 21.2.96 51.57.96 51.57s14.94 5.78 25.06 4.82 19.68-4.75 19.68-4.75 10.83-77.94 15.16-95.99c2.56-10.69 41.09-102.15 41.09-102.15s.17 54.69 1.63 77.82c2.08 32.92 9.63 124.51 9.63 124.51s6.78 2 22.69 2 23.13-3.37 23.13-3.37 0-22.17 2.41-42.89 8.67-55.42 7.71-72.29c-.96-16.87 25.54-113.25 32.77-144.58 7.23-31.33-16.59-103.46-16.59-103.46l-135.68 23.53Z"
        style={{
          fill: '#6d9454',
        }}
      />
      <path
        d="m1621.46 558.71 40.47-11.62s-5.15-22.45-8.8-40.21c-3.2-15.62-7.96-42.04-16.19-49.06-11.94-10.19-30.63-14.64-38.28-17.76 1.93 17.54-24.23 14.5-36.63 14.67-13.03.18-24.37-13.65-26.48-16.45-2.23.35-4.47.73-6.71 1.15-6.55 1.22-13.07 2.74-19.2 4.63-1.06.33-25.42 6.95-31.98 19.51-9.88 18.9-26.3 80.38-26.3 80.38s28.8 9.44 41.2 13.03c.22 15.6-3.91 27.07-11.85 52.88-6.17 20.06-15.22 70.15-15.22 70.15s49.33 2.09 91.46 4.35c42.13 2.26 92.27-12.45 92.27-12.45s-5.16-33.83-13.55-54.19c-8.8-21.36-12.32-50.95-14.21-59.02Z"
        style={{
          fill: '#efbbba',
        }}
      />
      <path
        d="M1562.34 368.27c-10.57-.9-33.48-5.24-33.48-5.24s-9.37 39.04-2.27 50.48c3.05 4.91 6.48 8.65 10.15 11.58-.23 1.81-.56 3.58-1.03 5.28-2.25 8.15-3.57 8.38-3.57 8.38s-1.64 25.53 26.97 23.2c18.73-1.53 23.67-3.82 20.76-3.62.26-1.1-8.29-14.82-5.58-19.61 5.05-8.91 11.86-16.28 15.53-26.97 3.78-11 6.66-27.49 7.9-34-5.74-1.9-24.77-8.58-35.38-9.49Z"
        style={{
          fill: '#e0a758',
        }}
      />
      <path
        d="M1626.57 459.3c-1.05-10.81-8.4-50.67-9.25-60.92-4.48-54.1-13.02-66.38-49.54-69.57-32.07-2.8-43.6 20.28-52.64 49.35-6.36 20.45 1.51 44.99 8.51 62.34 2.32-.43 8.42-1.59 8.42-1.59s1.4-.38 3.65-8.53c.47-1.7.8-3.48 1.03-5.28-3.67-2.94-7.1-6.68-10.15-11.58-7.1-11.44 3.29-44.92 3.29-44.92s23.16 4.81 33.58 6.85c11.93 2.33 25.93 4.21 31.67 6.11-1.24 6.51-4.17 21.22-10.64 30.88-6.63 9.9-18.41 18.71-21.99 40.61-2.34 14.35 8.07 28.58 8.07 28.58l52.82 6.21s5.87-.95 3.18-28.53Z"
        style={{
          fill: '#feca21',
        }}
      />
      <path
        d="M1553.51 406.13c3.38-1.14 4.82.28 6.11.41 1.41.14 3.79-.59 5.69 1.87 2.9 3.75 3.41 7.02 3.67 9.16.29 2.34-2.61 3.03-4.03 3.59-3.29 1.29-3.79.75-8.58.18-4.31-.51-6.9-1.8-8.54-3.92-1.3-1.68-2.49-2.44-1.7-4.76.86-2.54 3.99-5.38 7.37-6.52Zm-.63 7.78c.12 1.03.56 1.03 4.27 1.67 3.7.64 5.84 1.04 5.7-.25-.12-1.03-1.62-2.9-4.53-3.29-4.21-.57-5.51 1.24-5.44 1.87Z"
        style={{
          fill: '#d78b3b',
        }}
      />
      <path
        style={{
          fill: '#008db5',
        }}
        d="m1537.86 382.47 4.14 2.54.95-1.62-4.11-2.57-.98 1.65z"
      />
      <path
        d="M1544.88 381.75c-2.24-.24-3.98 1.1-4.14 3.31-.15 2.21 1.18 3.25 3.18 3.6 2.36.41 3.87-.89 4.26-3.14.27-1.59-.99-3.52-3.3-3.77ZM1582.99 388.68l-4.99 1.61-.49-1.8 4.96-1.65.52 1.84z"
        style={{
          fill: '#008db5',
        }}
      />
      <path
        d="M1576.48 386.83c2.24.23 3.67 1.91 3.35 4.1-.31 2.19-1.83 2.94-3.86 2.85-2.39-.1-3.6-1.68-3.51-3.96.06-1.61 1.7-3.23 4.01-2.99Z"
        style={{
          fill: '#008db5',
        }}
      />
      <path
        style={{
          fill: '#235a96',
        }}
        d="m1573.18 385.91 12.35-1.11-.29-2.69-11.96 1.45-.1 2.35zM1538.92 376.92l11.15 4.98 1.02-2.32-11.22-5.27-.95 2.61z"
      />
    </svg>
  )
}

export default SiblingStart
